export { default as HospitalContent } from "./HospitalContent"
export { default as ReviewTabContent } from "./ReviewTabContent"
export { default as TreatmentCaseTabContent } from "./TreatmentCaseTabContent"
export { default as HospitalTabContent } from "./HospitalTabContent"
